import { render, staticRenderFns } from "./TeacherSharing.vue?vue&type=template&id=238fb31a"
import script from "./TeacherSharing.vue?vue&type=script&lang=js"
export * from "./TeacherSharing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('238fb31a')) {
      api.createRecord('238fb31a', component.options)
    } else {
      api.reload('238fb31a', component.options)
    }
    module.hot.accept("./TeacherSharing.vue?vue&type=template&id=238fb31a", function () {
      api.rerender('238fb31a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/dynamic_time/TeacherSharing.vue"
export default component.exports